import { Controller } from "@hotwired/stimulus"
import autoCompleteJS from "@tarekraafat/autocomplete.js"
import htmlToElement from '../utilities/html_to_element'
import { xCircleSolid, cubeOutline } from '../utilities/heroicons'

export default class extends Controller {
  static values = {
    rentalId: String,
    autocompletePath: String
  }

  connect() {
    $("#productSearchModal").on("shown.bs.modal", () => {
      $("#products-search").trigger("focus")
    })
    $("#productSearchModal").on("hidden.bs.modal", () => {
      $("#products-search").val("")
    })

    this.autoComplete = new autoCompleteJS({
      placeHolder: "Cari Merk, Nama Produk atau Kode Unit",
      selector: "#products-search",
      wrapper: false,
      debounce: 500,
      data: {
        src: async (phrase) => {
          try {
            const url = `${this.autocompletePathValue}?phrase=${phrase}`
            const source = await fetch(url)
            const data = await source.json()

            return data.results
          } catch(error) {
            return []
          }
        },
        keys: ["caption"]
      },
      resultsList: {
        destination: "#searchResult",
        position: "afterbegin",
        class: "list-group list-group-flush tw-shadow tw-rounded-0",
        noResults: true,
        maxResults: 20,
        element: (list, data) => {
          if (data.results.length == 0) {
            const info = `
              <div class="list-group-item tw-border-b-0 tw-text-gray-700 tw-p-4 tw-py-8 tw-justify-center tw-flex tw-items-center">
                ${xCircleSolid("tw-h-5 tw-w-5 tw-mr-2")}
                <span>
                  Tidak ada hasil untuk <span class="tw-font-semibold">${data.query}</span>
                </span>
              </div>
            `
            list.classList.remove("tw-shadow")
            list.prepend(htmlToElement(info));
          }
        }
      },
      resultItem: {
        class: "list-group-item list-group-item-action tw-p-4 tw-border-b",
        highlight: { render: true },
        element: (item, data) => {
          const image_picture_element = `
            <div class="tw-h-auto tw-w-[80px] lg:tw-w-[100px]">
              <img src="${data.value.picture_url}" class="tw-w-full tw-rounded"/>
            </div>
          `
          const itemIcon = `
            <div class="tw-h-[80px] lg:tw-h-[100px] tw-w-[80px] lg:tw-w-[100px]">
              <div class="tw-h-full tw-flex tw-items-center tw-justify-center">
                ${cubeOutline("tw-h-12 tw-w-12")}
              </div>
            </div>
          `
          const image = data.value.type == "Unit" ? itemIcon : image_picture_element
          item.innerHTML = `
            <div class="tw-flex tw-items-start">
              <div class="tw-mr-4">
                ${image}
              </div>
              <div class="tw-space-y-1 lg:tw-space-y-2">
                <div class="tw-text-gray-700 tw-font-medium">${data.match}</div>
                <div class="">${data.value.type}</div>
              </div>
            </div>
          `
        }
      },
      events: {
        input: {
          selection: (event) => {
            const url = event.detail.selection.value.path

            $("#productSearchModal").modal("hide")
            Turbolinks.visit(url)
          },
          close: (event) => {
            if (event.currentTarget.value.length != 0) {
              this.autoComplete.open()
            }
          }
        }
      }
    })
  }
}
